import React, {PropsWithChildren} from 'react';
import {Disclosure as HeadlessDisclosure} from "@headlessui/react";
import {ChevronUpIcon} from "@heroicons/react/solid";
import {concatenate} from "../../services/string";

// Types ----

export type DisclosureProps = {
  name: string | React.ReactNode
  defaultOpen?: boolean
  dark?: boolean
  dragHandle?: React.ReactElement
  isDragging?: boolean
}

// Component ----

function Disclosure({name, defaultOpen, dark, dragHandle, isDragging, children}: PropsWithChildren<DisclosureProps>) {

  const buttonBaseClasses = 'flex w-full justify-between items-center px-4 py-2 text-left font-medium ' +
    'text-gray-900 focus:outline-none focus-visible:ring focus-visible:ring-brand ' +
    'focus-visible:ring-opacity-75'

  return (
    <HeadlessDisclosure defaultOpen={defaultOpen}>
      {({open}) => (
        <>
          <HeadlessDisclosure.Button
            className={concatenate(
              buttonBaseClasses,
              open ? 'rounded-t-lg border-b border-gray-200' : 'rounded-lg',
              dark ? 'bg-gray-200 hover:bg-gray-300' : 'bg-gray-100 hover:bg-gray-200',
            )}
          >
            <div className='truncate'>
              <div className="flex gap-2">
                {/* Drag handle */}
                {!!dragHandle && dragHandle}

                {/* Title */}
                <div className='truncate pr-3'>{name}</div>
              </div>
            </div>

            {/* Open/closed indicator */}
            <div>
              <ChevronUpIcon
                className={concatenate(
                  'h-5 w-5 text-brand',
                  open && 'rotate-180 transform',
                )}
              />
            </div>
          </HeadlessDisclosure.Button>

          <HeadlessDisclosure.Panel
            className={concatenate(
              'rounded-b-lg p-4',
              dark ? 'bg-gray-100' : 'bg-gray-50',
            )}
          >
            {children}
          </HeadlessDisclosure.Panel>
        </>
      )}
    </HeadlessDisclosure>
  );
}

// Export ----

export default Disclosure;